import { render, staticRenderFns } from "./AulasRealizadas.vue?vue&type=template&id=56626231&scoped=true"
import script from "./AulasRealizadas.vue?vue&type=script&lang=js"
export * from "./AulasRealizadas.vue?vue&type=script&lang=js"
import style0 from "./AulasRealizadas.vue?vue&type=style&index=0&id=56626231&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56626231",
  null
  
)

export default component.exports